import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './InvoiceData.css';
import Date from 'components/shared/text/Date';
import Number from 'components/shared/text/Number';
import Input from 'components/shared/input/Input';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import { todayValidation } from 'services/utils/date-util';
import MultipleSelectList from 'components/shared/select/MultipleSelectList';
import Button from 'components/shared/button/Button';

class InvoiceData extends Component {
  static propTypes = {
    completionDate: PropTypes.string,
    cost: PropTypes.string,
    customEmail: PropTypes.string,
    customEmailValid: PropTypes.bool,
    dueDate: PropTypes.string,
    edit: PropTypes.bool,
    emails: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        email: PropTypes.string,
      })
    ),
    purchaseOrder: PropTypes.string,
    showSendTo: PropTypes.bool,
    to: PropTypes.string,
    users: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        email: PropTypes.string,
        name: PropTypes.name,
        selected: PropTypes.bool,
      })
    ),
    onAttributeChange: PropTypes.func,
    onCustomEmailAdd: PropTypes.func,
    onCustomEmailChange: PropTypes.func,
    onEmailRemove: PropTypes.func,
    onUsersAdd: PropTypes.func,
    onUserSelected: PropTypes.func,
  };

  static defaultProps = {
    customEmail: '',
    customEmailValid: true,
    edit: false,
    emails: [],
    purchaseOrder: '',
    showSendTo: true,
    users: [],
  };

  render() {
    return (
      <div className="invoice-data">
        <div className="table-container">
          <div className="form-table">
            <div>
              <div className="invoice-data-label">To</div>
              <div>{this.props.to}</div>
            </div>
            {this.props.purchaseOrder !== '' &&
              this.props.purchaseOrder !== null && (
                <div>
                  <div className="invoice-data-label">Purchase Order</div>
                  <div>{this.props.purchaseOrder}</div>
                </div>
              )}
            <div>
              <div className="invoice-data-label">Completion Date</div>
              <div className="invoice-data-bold">
                <Date value={this.props.completionDate} format="M/D/YYYY" />
              </div>
            </div>
            <div>
              <div className="invoice-data-label">Due Date</div>
              <div className="invoice-data-bold">
                {this.props.edit ? (
                  <DatetimePicker
                    isValidDate={todayValidation}
                    placeholder=""
                    value={this.props.dueDate}
                    onChange={this.handleAttributeChange.bind(this, 'dueDate')}
                  />
                ) : (
                  <Date value={this.props.dueDate} format="M/D/YYYY" />
                )}
              </div>
            </div>
            <div>
              <div className="invoice-data-label">Invoice Amount</div>
              <div className="invoice-data-bold orange">
                <Number value={this.props.cost} format="$ 0,0" />
              </div>
            </div>
            {this.props.showSendTo && (
              <div>
                <div className="invoice-data-label emails">Send to</div>
                <div>
                  <div className="invoice-emails-container">
                    {this.props.edit ? (
                      <React.Fragment>
                        <div>
                          <div>
                            <MultipleSelectList
                              options={this.props.users.map((user) => {
                                return {
                                  id: user.id,
                                  selected: user.selected,
                                  value: `${user.name} <${user.email}>`,
                                };
                              })}
                              show={5}
                              onSelect={this.handleUserSelected}
                            />
                          </div>
                          <div>
                            <Button
                              className="button-orange"
                              disabled={
                                this.props.users.filter((user) => user.selected)
                                  .length === 0
                              }
                              label="Add"
                              onClick={this.handleUsersAdd}
                            />
                          </div>
                        </div>
                        <div>
                          <div>
                            <Input
                              className="email-input"
                              valid={this.props.customEmailValid}
                              value={this.props.customEmail}
                              onChange={this.handleCustomEmailChange}
                            />
                            {!this.props.customEmailValid && (
                              <div className="invalid-message">
                                Invalid email, please verify.
                              </div>
                            )}
                          </div>
                          <div>
                            <Button
                              className="button-orange"
                              disabled={this.props.customEmail === ''}
                              label="Add"
                              onClick={this.handleCustomEmailAdd}
                            />
                          </div>
                        </div>
                        <div>
                          <div>
                            <MultipleSelectList
                              noValuesMessage="No emails"
                              options={this.props.emails.map((value) => {
                                return {
                                  id: value.id,
                                  value: value.email,
                                };
                              })}
                              readOnly={true}
                              onRemove={this.props.onEmailRemove}
                            />
                          </div>
                          <div />
                        </div>
                      </React.Fragment>
                    ) : (
                      <div>
                        <MultipleSelectList
                          noValuesMessage="No emails"
                          options={this.props.emails.map((value) => {
                            return {
                              id: value.id,
                              value: value.email,
                            };
                          })}
                          readOnly={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  handleAttributeChange = (attribute, value) => {
    if (this.props.onAttributeChange) {
      this.props.onAttributeChange(attribute, value);
    }
  };

  handleCustomEmailAdd = () => {
    if (this.props.onCustomEmailAdd) {
      this.props.onCustomEmailAdd();
    }
  };

  handleUsersAdd = () => {
    if (this.props.onUsersAdd) {
      this.props.onUsersAdd();
    }
  };

  handleUserSelected = (id) => {
    if (this.props.onUserSelected) {
      this.props.onUserSelected(id);
    }
  };

  handleCustomEmailChange = (value) => {
    if (this.props.onCustomEmailChange) {
      this.props.onCustomEmailChange(value);
    }
  };
}

export default InvoiceData;



// WEBPACK FOOTER //
// ./src/components/admin/invoices/InvoiceData.js